export const sunHours = {
    'Adelaide': 4.2,
    'Brisbane': 4.2,
    'Canberra': 4.3,
    'Melbourne': 3.6,
    'Perth': 4.4,
    'Sydney': 3.2,
    'Townsville': 5,
}

export const salesType = [
    "Solar", "Retro Fit", "Battery Only"
]

export const Phases = [
    "Single", "Dual", "Three"
]